import api from '@/api'
import axios from 'axios'
import request from '@/api/helpers/request'

/**
 *
 * @param phoneUrl - endpoint для отправки номера
 * @param checkCodeUrl - endpoint для отправки кода для проверки
 * @constructor
 */
export default function AuthService ({ phoneUrl, checkCodeUrl } = {}) {
  this.checkCodeUrl = checkCodeUrl
  this.phoneUrl = phoneUrl
  this.changePassword = (password, newPassword, confirmNewPassword) => {
    return api.auth.changePassword({ password, newPassword, confirmNewPassword })
  }
  /**
   * @param email
   */
  this.register = (email) => {
    return api.auth.registerWithEmail({ email })
  }
  this.restorePassword = (password, confirmPassword) => {
    return api.auth.restorePassword({ password, confirmPassword })
  }
  this.setPassword = async (remember, email, isGeneratePassword, password, confirmPassword) => {
    try {
      const response = await api.auth.setPassword({ remember, email, isGeneratePassword, password, confirmPassword })
      // обновляем csrf token после авторизации
      if (response.csrf) {
        axios.defaults.headers.common['x-csrf-token'] = response.csrf
        request.defaults.headers.common['x-csrf-token'] = response.csrf
      }
      return response
    } catch (e) {
      return e
    }
  }
  /**
   * @param email
   */
  this.recoveryPassword = (email) => {
    return api.auth.recoveryPassword({ email })
  }
  /**
   * @param email
   * @param password
   * @param remember
   */
  this.login = async (email, password, remember) => {
    try {
      const response = await api.auth.loginWithEmail({ email, password, remember })
      // обновляем csrf token после авторизации
      if (response.csrf) {
        axios.defaults.headers.common['x-csrf-token'] = response.csrf
        request.defaults.headers.common['x-csrf-token'] = response.csrf
      }
      return response
    } catch (e) {
      return e
    }
  }
  this.verifyEmail = (email, remember) => {
    return api.auth.verifyEmail({ email, remember })
  }
  this.verifyPhone = (phone) => {
    this.phone = phone
    return api.auth.verifyPhone({ phone, url: this.phoneUrl })
  }
  this.sendVerifyCode = (email, isResend) => {
    return api.auth.sendVerifyCode({ email, isResend })
  }
  this.sendOneTimePass = (email, code, remember) => {
    return api.auth.sendOneTimePass({ email, code, remember })
  }
  /**
   * @param code - код верификации
   * @param remember - флаг "Запомнить меня"
   */
  this.verifyCode = async ({ code, remember }) => {
    if (this.phone) {
      const phone = this.phone
      try {
        const response = await api.auth.verifyCode({ phone, url: this.checkCodeUrl, code, remember })
        // обновляем csrf token после авторизации
        if (response.csrf) {
          axios.defaults.headers.common['x-csrf-token'] = response.csrf
          request.defaults.headers.common['x-csrf-token'] = response.csrf
        }
        return response
      } catch (e) {
        return e
      }
    }
  }
}
